<template>
  <div :class="formGroupClass">
    <slot name="before"/>
    <div v-if="showWarning" class="form-field-warn" style="right: 0 !important;">
      <label>!</label>
      <div class="form-field-warn-text">
        <div>Дата выдачи не соответствует серии паспорта</div>
      </div>
    </div>
    <hint :value="inputHint" />
    <label :for="inputId" class="control-label">{{ inputLabel }}</label>
    <div class="input-group">
      <date-picker
        v-model="inputValue"
        v-facade="dateMask"
        :id="inputId"
        :disabled="disabled"
        :value-type="dateValueType"
        :format="dateFormat"
        :disabled-date="isDisabledDate"
        @input="emitValue('input', $event)"
        @change="emitValue('change', $event)"
        @blur="emitValue('change', $event)"
      />
    </div>
    <error-help-block :has-errors="hasInputErrors" :current-error="actualErrorMessage"/>
    <slot name="after"/>
  </div>
</template>

<script>
import applicationInputMixin from '../../../../mixins/applicationInputMixin'
import applicationFormMixin from '../../../../mixins/applicationFormMixin'
import visitorsSectionMixin from '../../../../mixins/application-form/visitorsSectionMixin'
import visitorInputMixin from '../../../../mixins/application-form/visitorInputMixin'
import datePickerConfigMixin from '../../../../mixins/application-form/datePickerConfigMixin'
import Hint from '@/common/components/inputs/components/Hint.vue'

export default {
  name: 'IdentificationDateOfInput',

  components: { Hint },

  mixins: [
    applicationInputMixin,
    applicationFormMixin,
    visitorsSectionMixin,
    visitorInputMixin,
    datePickerConfigMixin
  ],

  props: {
    inputLabel: {
      default: 'Дата выдачи'
    },

    inputName: {
      default: 'identification_date_of'
    },

    inputHint: {
      default: undefined
    }
  },

  computed: {
    inputId () {
      let inputId = `form-visitor-identification-date-of-${this.visitorIndex}`
      if (this.transportIndex !== null) {
        return `form-visitor-transport-${this.transportIndex}-driver-${this.visitorIndex}-identification-date-of`
      }

      return inputId
    },

    showWarning() {
      return this.isView && this.identificationNumberNeedCheck()
    }
  },

  methods: {
    disabledDate (date) {
      return false
    },

    identificationNumberNeedCheck() {
      let identificationNumber = this.visitor.personal.identification_number
      let identificationDateOf = this.inputValue
      if (identificationNumber.length > 10 && this.russianCivilPassportSelected(this.visitor) && identificationDateOf !== null) {
        let yearInSeries = identificationNumber.substring(2, 4)

        return this.checkPassportSeriesIsAccordToDate(yearInSeries, identificationDateOf)
      }

      return false
    }
  }
}
</script>
